export enum RouteVariables {
  ARTICLE = ':article',
  CATEGORY = ':category',
  SUB_CATEGORY = ':subCategory',
  SLUG = ':slug',
}
